export enum CourseStatus {
  PENDING = 'pending',
  FIRED = 'fired',
  COMPLETE = 'complete',
}

export enum CourseFiringMode {
  MANUAL = 'manual',
  AUTO = 'auto',
}

